import axios from 'axios';

import axiosGdt from '../utils/axiosGdt';

import { GDTApiErrors } from '@/types';
import {
  DataPostRegister,
  ResponseInitRegister,
  ResponseNameValid,
  ResponseRegisterSuccess,
  TypeIdNombre,
} from '@/types/register';
import { axiosErrorHandler, getPlatformId, URLs } from '@/utils';

type TypeGeografia<T> = {
  estado: boolean;
  geografia: T[];
};

export const getInitDataRegister = axiosErrorHandler(async () => {
  const response = await axiosGdt.get<ResponseInitRegister>(
    URLs.REGISTRO.LOAD + `&idPlataforma=${getPlatformId()}`
  );
  return response.data;
});

export const getPartyProvince = axiosErrorHandler(async (id: number) => {
  const url = `${URLs.PARTIDOS}&id=${id}`;
  const response = await axiosGdt.get<TypeGeografia<TypeIdNombre>>(url);
  return response.data;
}, 'Error al obtener los partidos de la provincia seleccionada');

export const getLocationParty = axiosErrorHandler(async (id: number) => {
  const url = `${URLs.LOCALIDADES}&id=${id}`;
  const response = await axiosGdt.get<TypeGeografia<TypeIdNombre>>(url);
  return response.data;
}, 'Error al obtener las localidades del partido seleccionada');

export const getSchoolsLocation = axiosErrorHandler(
  async (id: number, isHighSchool: boolean) => {
    const url = `${
      !isHighSchool ? URLs.ESCUELAS_PRIMARIA : URLs.ESCUELAS_SECUNDARIA
    }/${id}`;
    const response = await axios.get<
      {
        id: number | string;
        n: string;
      }[]
    >(url);
    return response.data;
  },
  'Error al obtener las escuelas'
);

export const registerUserData = axiosErrorHandler(
  async (value: DataPostRegister | null, withSchool: boolean, step: number) => {
    const hinchaFinal = value?.hincha === -1 ? value?.hinchaOtro : '';
    let userDataForm = {
      dontTranscode: 1,
      nombre: value?.nombre,
      apellido: value?.apellido,
      tipoDocumentoId: value?.tipodoc,
      nroDocumento: value?.numdoc,
      reNroDocumento: value?.numdoc2,
      tmp_dia: value?.dianac,
      tmp_mes: value?.mesnac,
      tmp_anio: value?.anionac,
      sexo: value?.sexo,
      hinchaId: value?.hincha,
      hinchaOtro: hinchaFinal,
      nombreEquipo: value?.nombreEquipo,
      nroDocumentoExtranjero: value?.nroDocumentoExtranjero,
      docArg: value?.docArg,
      idPais: value?.idPais,
      email: value?.email,
      reemail: value?.email2,
      recibeInfo3eros: value?.terceros,
      recibeSms: value?.sms,
      password: value?.pass,
      aceptaTerminosYCondiciones: true,
    };
    if (step !== 3) {
      userDataForm = {
        ...userDataForm,
        ...{ 'dry-run': 1 },
      };
    }
    if (withSchool) {
      const dataSchool = {
        tipoescuela: value?.tipoescuela,
        localidadEscuelaId: value?.localidadEscuelaId,
        escuelaId: value?.escuelaId,
      };
      userDataForm = { ...userDataForm, ...dataSchool };
    }
    const url = `${URLs.REGISTRO.SAVE}&idPlataforma=${getPlatformId()}`;
    const response = await axiosGdt.post<
      GDTApiErrors | ResponseRegisterSuccess
    >(url, userDataForm, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    });
    return response.data;
  },
  'Error al grabar registro'
);

export const getNameTeamValid = axiosErrorHandler(async (name: string) => {
  const url = `${URLs.NOMBRE_DE_EQUIPO}&nombre=${encodeURIComponent(name)}`;
  const response = await axiosGdt.get<ResponseNameValid>(url);
  return response.data;
});
